module.exports = __webpack_public_path__ + "static/ic-globe-0e32773c5b65c5d1ff86795cab2bfa44.png";